import { createTypes } from 'redux-recompose';

export const actions = createTypes(['SET_SELECTEDELEMENTS', 'SET_LISTAFORNITORE'], '@@PML');

const actionCreators = {
    SET_SELECTEDELEMENTS: (response) => ({ type: actions.SET_SELECTEDELEMENTS, response: response }),
    SET_LISTAFORNITORE: (response) => ({ type: actions.SET_LISTAFORNITORE, response: response }),
  };
  
  export default actionCreators;